import { ButtonBase } from '@bonniernews/dn-design-system-web/components/button/button-base.tsx'
import type { ButtonToggleProps } from '@bonniernews/dn-design-system-web/components/button/button-types.ts'

/**
 * - GitHub: [BonnierNews/dn-design-system/web/src/components/button-toggle](https://github.com/BonnierNews/dn-design-system/tree/main/web/src/components/button-toggle)
 * - Storybook: [Buttons > ButtonToggle](https://designsystem.dn.se/?path=/docs/basic-buttons-buttontoggle--docs)
 *
 *
 * ### Javascript
 *
 * ```javascript
 * import dsButtonToggle from '@bonniernews/dn-design-system-web/components/button/button-interactions.js'
 * const toggleElements = Array.from(document.getElementsByClassName("ds-btn--toggle"));
 * dsButtonToggle(toggleElements);
 * ```
 *
 * The component will not include styling by itself. Make sure to include the right styles for the component. See example below:
 * `@use "@bonniernews/dn-design-system-web/components/button-toggle/button-toggle.scss";`
 */

export const ButtonToggle = ({
  selected = false,
  text,
  selectedText,
  disabled = false,
  variant = 'primary',
  size = 'md',
  fullWidth = false,
  mobileFullWidth = false,
  isIconButton = false,
  iconName,
  selectedIconName,
  loading = false,
  attributes = {},
  classNames,
  forcePx = false,
}: ButtonToggleProps) => {
  return (
    <ButtonBase
      {...{
        selected,
        text,
        disabled,
        variant,
        size,
        fullWidth,
        mobileFullWidth,
        isIconButton,
        iconName,
        selectedIconName,
        loading,
        classNames,
        attributes,
        forcePx,
        isToggle: true,
        selectedText,
        type: 'button',
      }}
    />
  )
}

export default ButtonToggle
